import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function RoofIcon(props) {
	return (
		<IconBase type="roof" {...props}>
			<path d="M19 12.7973L21.8534 14.9567L20.6466 16.5515L12 10.0081L3.35343 16.5515L2.14655 14.9567L12 7.5L17 11.2838V9.5H19V12.7973Z" />
			<path d="M12 10.6905L15.2511 13.1508L14.9494 13.5495L12 11.3176L9.05062 13.5495L8.7489 13.1508L12 10.6905Z" />
		</IconBase>
	);
}
RoofIcon.propTypes = iconPropTypes;
